<template>

<div class="status-content">
	<TopContent>
		<span slot="headline">
	    	<!-- {{getSingleProperty.address}} --> Adresselinje 123
	  	</span>
	  	<span slot="text">
	    	<!-- {{getSingleProperty.zip_code}} {{getSingleProperty.city}} --> Postnummer by
	  	</span>
		<div slot="actions" class="actions">
			<button class="transparent">
				{{$t('button.contract.recall')}}
			</button>
			<button class="transparent">
				{{$t('button.contract.preview')}}
			</button>
			<button class="transparent">
				{{$t('button.contract.edit')}}
			</button>
			<a href="" class="circle-icon">
				<SvgIcon icon="more" />
			</a>
		</div>
	</TopContent>
	<div class="inner main-content">
		<div class="label-row">
			<LabelCol v-for="col in labels" v-bind:key="col.id">
				<span slot="label">{{ col.label }}</span>
				<span slot="info">{{ $t(col.input) }}</span>
			</LabelCol>
		</div>
		<div class="status-row four-items">
			<StatusCol 
				v-for="item in statusCols" 
				v-bind:key="item.id" 
				v-bind:class="{ progress: item.inProgress, finished: item.completed }"
			>
				<span slot="icon">
					<SvgIcon :icon="item.icon" />
				</span>
				<span slot="label">{{ item.label }}</span>
				<div class="status-circle" slot="status">
					<span class="blop-left"><SvgIcon icon="blop-left" /></span>
					<div class="icon" v-if="item.inProgress">	
						<SvgIcon icon="loading" />
					</div>
					<div class="icon" v-else>
						<SvgIcon icon="white-checkmark" />		
					</div>
					<span class="blop-right"><SvgIcon icon="blop-right" /></span>
				</div>
				<div class="list" slot="list" v-if="item.inProgress">
					<ul>
						<li class="checked">
							<div class="before"></div>
							<div class="checkmark">
								<SvgIcon icon="checkmark" />
							</div>
							<p>Sent to tenant for signing</p>
						</li>
						<li class="checked">
							<div class="before"></div>
							<div class="checkmark">
								<SvgIcon icon="checkmark" />
							</div>
							<p>Tenant has opened signing request e-mail</p>
						</li>
						<li>
							<div class="before"></div>
							<div class="checkmark">
								<SvgIcon icon="checkmark" />
							</div>
							<p>Tenant has seen the contract</p>
						</li>
						<li>
							<div class="before"></div>
							<div class="checkmark">
								<SvgIcon icon="checkmark" />
							</div>
							<p>Tenant has signed the contract</p>
						</li>
						<li>
							<div class="before"></div>
							<div class="checkmark">
								<SvgIcon icon="checkmark" />
							</div>
							<p>Sent to landlord for signing</p>
						</li>
					</ul>
				</div>
			</StatusCol>
		</div>
	</div>
</div>

</template>

<script>
    import Vue from 'vue';
    import SvgIcon from '../../components/Svg.vue';
    import TopContent from '../../components/TopContent.vue';
    import StatusCol from '../../components/StatusCol.vue';
    import LabelCol from '../../components/LabelCol.vue';

    export default {
    	components:{
			SvgIcon,
			TopContent,
			StatusCol,
			LabelCol
		},
		data: () => ({
			waiting: true,
			inProgress: true,
			completed: false,
			labels: [
				{
					id: 'label1',
					label: 'general.label.current-status',
					// Skal hente nuværende status på kontrakten
					input: 'Signing in progress'
				},
				{
					id: 'label2',
					label: 'Tenant',
					// Skal hente tenant name
					input: 'Michael Henriksen'
				},
				{
					id: 'label3',
					label: 'Landlord',
					// Skal hente udlejer
					input: 'City Apartments'
				},
				{
					id: 'label4',
					label: 'Occupancy date',
					// Skal hente indflytningsdato
					input: '01-08-2019'
				}
			],
			statusCols: [
				{
					id: 'col1',
					waiting: false,
					inProgress: false,
					completed: true,
					label: 'Contract',
					icon: 'contract-icon'
				},
				{
					id: 'col2',
					waiting: false,
					inProgress: false,
					completed: true,
					label: 'Approval',
					icon: 'watch-icon'
				},
				{
					id: 'col3',
					waiting: false,
					inProgress: true,
					completed: false,
					label: 'Signing',
					icon: 'pen-icon'
				},
				{
					id: 'col4',
					waiting: true,
					inProgress: false,
					completed: false,
					label: 'Finished',
					icon: 'check-icon'
				}
			]
		})
	}
</script>